module.exports = __webpack_public_path__ + "img/casino-city.65705028.jpg";